module.exports = __webpack_public_path__ + "static/media/cardstatus.201b1e99.svg";